import { Injectable } from '@angular/core';

/**
 * Holds primary key count and mapping bucket totals for the active edit data mapping view.
 * Used by DataMappingCanDeactivateGuard to warn when leaving without primary keys while
 * there are field rows in Unmapped, Mapped, or Aggregate.
 */
@Injectable()
export class DataMappingDeactivateWarningService {
  private primaryCount: number | null = null;
  /** Sum of Unmapped + Mapped + Aggregate information-bar counts (0 when none). */
  private unmappedMappedAggregateTotal: number | null = null;

  setPrimaryCount(count: number | null): void {
    this.primaryCount = count;
  }

  getPrimaryCount(): number | null {
    return this.primaryCount;
  }

  setUnmappedMappedAggregateTotal(total: number | null): void {
    this.unmappedMappedAggregateTotal = total;
  }

  getUnmappedMappedAggregateTotal(): number | null {
    return this.unmappedMappedAggregateTotal;
  }

  clear(): void {
    this.primaryCount = null;
    this.unmappedMappedAggregateTotal = null;
  }
}
